import { render, staticRenderFns } from "./LoginContent.vue?vue&type=template&id=b88d237a&scoped=true&"
import script from "./LoginContent.vue?vue&type=script&lang=js&"
export * from "./LoginContent.vue?vue&type=script&lang=js&"
import style0 from "./LoginContent.vue?vue&type=style&index=0&id=b88d237a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88d237a",
  null
  
)

export default component.exports